<script>
    import FileUpload from './FileUpload';
    import FilesUpload from './FilesUpload';
    import {trumbowyg} from '../../mixins/trumbowyg'

    export default {
        mixins: [trumbowyg],
        components: {
            'file-upload': FileUpload,
            'files-upload': FilesUpload
        },
        name: "StepSix",
        props: {
            'course': Object,
            'description': Object
        },
        data() {
            return {
                loading: false,
                imageMaxSize: 4, // megabytes,
                message: null,
                textValidationError: false
            }
        },
        watch: {
            'description.text': {
                handler(val) {
                    this.onCheckDescriptionLimit(val)
                }
            },
        },
        mounted() {
            var self = this;

            var courseId = self.course.courseId;

            $('document').ready(function () {

                self.loading = true;
                self.$bus.$emit('start-spinner');

                $('#my-gallery-dropzone').addClass('dropzone');
                $('#my-gallery-dropzone').dropzone({
                    uploadMultiple: true,
                    parallelUploads: 4,
                    acceptedFiles: "image/*",
                    maxFilesize: 16,
                    maxFiles: 10,
                    previewTemplate: $('body').find('#gallery_preview').html(),
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancella upload',
                    dictRemoveFile: 'Rimuovi',
                    dictFileTooBig: 'L\'immagine supera il limite consentito',
                    timeout: 10000,
                    url : `/api/course/${courseId}/gallery_image`,
                    init: function () {

                        var dropzone_self = this;

                        axios({
                            method: 'get',
                            url: `/course/${courseId}/gallery_images`
                        }).then((response) => {

                            var images = response.data;
                            images.forEach(function (image) {
                                dropzone_self.files.push(image);
                                dropzone_self.emit("addedfile", image);
                                dropzone_self.emit("thumbnail", image, image.thumb);
                                dropzone_self.emit("complete", image);
                            })

                            self.loading = false;
                            self.$bus.$emit('stop-spinner');
                        });
                        this.on("removedfile", function (file) {
                            $.post({
                                url: `/api/course/${courseId}/remove_gallery_image/${file.id}`,
                                data: {_token: $('[name="_token"]').val()},
                                dataType: 'json',
                                success: function (data) {
                                }
                            });
                        });
                    },
                    sending: function () {
                        // var dropzone_self = this;
                        // self.loading = true;
                    },
                    successmultiple: function (file, done) {
                        let response = done
                        file.forEach(function (file, index) {
                            file.id = response.uploaded[index];
                        })
                    },
                    success: function (file, done) {

                    }
                });

                $('#my-logo-dropzone').addClass('dropzone');
                $('#my-logo-dropzone').dropzone({
                    uploadMultiple: false,
                    maxFiles: 1,
                    acceptedFiles: "image/*",
                    maxFilesize: 8,
                    previewTemplate: $('body').find('#logo_preview').html(),
                    addRemoveLinks: true,
                    dictRemoveFile: 'Rimuovi',
                    dictCancelUpload: 'Cancella upload',
                    dictFileTooBig: 'L\'immagine supera il limite consentito',
                    timeout: 10000,
                    url : `/api/course/${courseId}/logo`,
                    init: function () {

                        var dropzone_self = this;

                        axios({
                            method: 'get',
                            url: `/course/${courseId}/logo`
                        }).then((response) => {
                            var image = response.data;

                            if (!_.isEmpty(image)) {
                                dropzone_self.files.push(image);
                                dropzone_self.emit("addedfile", image);
                                dropzone_self.emit("thumbnail", image, image.thumb);
                                dropzone_self.emit("complete", image);
                            }
                        })

                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });

                        this.on("processing", function(file) {
                            if (dropzone_self.files.length != 0) {
                                this.removeAllFiles();
                            }
                        });

                        this.on("removedfile", function (file) {
                            $.post({
                                url: `/api/course/${courseId}/remove_logo`,
                                data: {_token: $('[name="_token"]').val()},
                                dataType: 'json',
                                success: function (data) {
                                }
                            });
                        });
                    },
                    success: function (file, done) {
                    }
                });
            });
        },
        methods: {
            onCheckDescriptionLimit(val) {
                if (val.length > 600) {
                    val = val.substr(0, 600)
                    this.$set(this.description, 'text', val)
                }
            },
            isLoading() {
                return this.loading;
            },
            onFile: function (file) {
                this.description.photo = file;
                this.description.filePath = '';
            },
            onFileGallery: function (file) {
                this.description.gallery.push(file);
            },
            removeFileGallery: function (index) {
                this.description.gallery.splice(index, 1);
            },
            onSizeExceeded(size) {
                this.message = 'Immagine troppo grande, prova con una piu piccola';
            },
            previousStep() {
                this.$emit('update-step', 5);
            },
            postForm() {
                if (this.validation()) {

                    let formData = new FormData();
                    if (!_.isEmpty(this.description.text)) {
                        formData.append('text', this.description.text);
                    } else {
                        formData.append('text', '');
                    }
                    formData.append('photo', this.description.photo);

                    if (this.description.gallery.length > 0) {

                        this.description.gallery.forEach((item, index) => {
                            formData.append('gallery[' + index + ']', item);
                        });
                    }
                    this.loading = true;
                    this.$bus.$emit('searching');
                    axios({
                        method: 'post',
                        url: '/courses/' + this.course.courseId + '/description',
                        data: formData,
                    }).then((response) => {
                    }).catch((error) => {
                        /*this.loading = false;
                        this.$bus.$emit('filtered');
                        this.message = 'Error';*/
                    });
                    this.loading = false;
                    this.$bus.$emit('filtered');
                    this.$emit('update-step', 7, 6);
                }
            },
            validation() {
                return true;
            }

        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepSix.vue